/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EvseType = {
    Ac: 'AC',
    Dc: 'DC',
    AcDc: 'AC_DC'
} as const;
export type EvseType = typeof EvseType[keyof typeof EvseType];


export function instanceOfEvseType(value: any): boolean {
    for (const key in EvseType) {
        if (Object.prototype.hasOwnProperty.call(EvseType, key)) {
            if (EvseType[key as keyof typeof EvseType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EvseTypeFromJSON(json: any): EvseType {
    return EvseTypeFromJSONTyped(json, false);
}

export function EvseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvseType {
    return json as EvseType;
}

export function EvseTypeToJSON(value?: EvseType | null): any {
    return value as any;
}

export function EvseTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EvseType {
    return value as EvseType;
}

